module.exports = __webpack_public_path__ + "img/bg-auth-overlay-2.5d25cafb.png";